import React from 'react'
import { Tabs } from 'material-ui'
import muiThemeable from 'material-ui/styles/muiThemeable'

// tab container with full page width used for secondary navigation
const NavigationTabs = ({ children, muiTheme, ...other }) => {
  const {
    custom: { metrics: { basePadding, tabNavigationHeight } },
    tabs: { padding },
    inkBarStyle,
  } = muiTheme
  return (
    <div>
      <div
        style={{
          position: 'absolute',
          backgroundColor: muiTheme.palette.primary1Color,
          left: 0,
          right: 0,
          height: tabNavigationHeight,
        }}
      />
      <Tabs
        style={{ margin: -basePadding }}
        inkBarStyle={inkBarStyle}
        contentContainerStyle={{ padding: basePadding }}
        tabItemContainerStyle={{ height: tabNavigationHeight, padding }}
        {...other}
      >
        {children}
      </Tabs>
    </div>
  )
}

export default muiThemeable()(NavigationTabs)



// WEBPACK FOOTER //
// ./src/components/NavigationTabs.js